import React from 'react';
import { Shield } from 'lucide-react';
import { hero } from '../mock';

const HeroLogo = () => (
  <div className="relative mx-auto mb-8 h-24 w-24">
    <div className="absolute inset-0 rounded-full border border-[#c99a2e]/30 animate-pulse-ring" />
    <div className="relative h-24 w-24 rounded-full bg-[#0d0d13] border border-[#c99a2e]/40 flex items-center justify-center shadow-[0_0_40px_-8px_rgba(224,184,76,0.35)]">
      <svg viewBox="0 0 64 64" width="52" height="52" fill="none">
        <defs>
          <linearGradient id="herologo" x1="0" y1="0" x2="64" y2="64">
            <stop offset="0" stopColor="#f3d98a" />
            <stop offset="1" stopColor="#c99a2e" />
          </linearGradient>
        </defs>
        <path d="M10 40c9-3 13-12 21-12 6 0 8 6 14 6 5 0 8-6 12-13" stroke="url(#herologo)" strokeWidth="3" strokeLinecap="round" />
        <path d="M8 32c6 0 9 4 13 4" stroke="url(#herologo)" strokeWidth="2.4" strokeLinecap="round" opacity="0.5" />
        <text x="15" y="30" fontFamily="Playfair Display, serif" fontSize="18" fontStyle="italic" fill="url(#herologo)">rw</text>
      </svg>
    </div>
  </div>
);

const Hero = ({ onStart, onPricing }) => {
  return (
    <section className="relative pt-32 pb-8 px-6">
      <div className="max-w-3xl mx-auto text-center animate-fade-up">
        <HeroLogo />
        <h1 className="font-serif-display text-[42px] leading-[1.12] sm:text-[56px] text-white">
          {hero.titleLine1}
          <br />
          <span className="gold-gradient-text">{hero.titleAccent}</span>
        </h1>
        <p className="mt-7 text-[15px] sm:text-[17px] leading-relaxed text-[#9a9aa4] max-w-2xl mx-auto">
          {hero.description}
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onStart}
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-gradient-to-b from-[#e8c766] to-[#d4af37] text-[#1a1500] font-semibold hover:from-[#f0d27a] hover:to-[#e0b84c] transition-all shadow-[0_8px_28px_-8px_rgba(212,175,55,0.6)] hover:-translate-y-0.5"
          >
            Start Pacing
          </button>
          <button
            onClick={onPricing}
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-[#121218] text-white font-semibold border border-[#2a2a33] hover:border-[#c99a2e]/50 hover:bg-[#16161d] transition-all"
          >
            View Pricing ($10/mo)
          </button>
        </div>

        <div className="mt-9 max-w-xl mx-auto rounded-xl bg-[#0e0e14]/70 border border-[#1e1e26] px-5 py-4 flex items-start gap-3 text-left">
          <Shield className="h-4 w-4 mt-0.5 text-[#c99a2e] shrink-0" />
          <p className="text-[12.5px] leading-relaxed text-[#7c7c86]">
            <span className="text-[#c99a2e] font-semibold">100% Private.</span> {hero.privacy}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
